import { useState, useEffect } from "react";
import { useParams,useNavigate, generatePath } from "react-router-dom";
import http from "../api/server";
import { CREATE_INSPECTION_PROPERTY_APPROVAL_HISTORY, SEND_NEXT_INSPECTION_DUEDATE } from "../api/apiPath";
import { useSelector } from "react-redux";
import Toaster from "./common/Toaster";

// import http from "../api/server";

const Approval = (props) => {
  const data = props.data;
  const isApprove = props.isApprove;
  const isDueDate = props.isDueDate;
  const inspectionRefnumber=  props.inspectionRefnumber;
   const navigate = useNavigate();
  const { onClose } = props;
  const param = useParams();
  const { clientNameParam, propertyMasterId } = param;
  const [validationFlag, setValidationFlag] = useState(false);
  const { userObj } = useSelector((state) => state.user);
  const [showLoader, setShowLoader] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [dateError, setDateError] = useState("");
  const [formData, setFormData] = useState({
    status: isApprove ? "Approved" : "Rejected",
    comment: "",
    propertyMasterId: propertyMasterId,
    inspectionApprovedDate: "",
    inspectionApprovedBy: ""
  });
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });

  useEffect(() => {

  }, []);


 const closeButton = () => {
   setToastData({
    toastShow: false,
    toastData: "",
    toastType: "",
   });
  };
  const handleValidationOnSave = async () => {
    
    let isValid = true;
    // Basic validation
    if (!formData.status || formData.status === "Select") {
      isValid = false;
    }
    if ((isApprove || isDueDate) && (!formData.dueDate || formData.dueDate === undefined)) {
      isValid = false;
    }
    if (!isDueDate && formData.status === "Rejected" && (!formData.comment || formData.comment.trim() === "")) {
      isValid = false;
    }
    setValidationFlag(!isValid);
    if (isValid) {
      setShowLoader(true);
      if(isDueDate === true){
        const payload = {
          inspectionPropertyInfoId: data.inspectionPropertyInfoId,
          propertyMasterId: formData.propertyMasterId,
          newInspectionDueDate:formData.dueDate,
          LoggedInUserEMail: userObj?.userEmail
        };
        try {
          const response = await http.put(SEND_NEXT_INSPECTION_DUEDATE, payload);
          if (!response.status) {
            throw new Error(`HTTP error! status: ${response?.status}`);
          }
          response.status === 200
          ? setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Next Inspection Due Date has been set successfully",
          })
          : setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in saving data, please try again",
          });
          setShowLoader(false);
          setDisableButton(true);
          setTimeout(() => {
               handleCancel();
            navigate(
              generatePath("/client/:clientNameParam/property-form", {
                      clientNameParam,
                    })
            );
        }, 3000);
         
        } catch (error) {
          console.error("API Error:", error);
          // Display error message to user, if needed
        }
        finally {
          setShowLoader(false);
        }
      }else{
        const payload = {
          inspectionPropertyInfoId: data.inspectionPropertyInfoId,
          approverName: userObj.userName, // optionally derive this from user context
          status: formData.status,
          Comment: formData.comment,
          DueDate:formData.dueDate,
          LoggedInUserEmail: userObj?.userEmail
        };
        try {
          const response = await http.post(CREATE_INSPECTION_PROPERTY_APPROVAL_HISTORY, payload);
          if (!response.status) {
            throw new Error(`HTTP error! status: ${response?.status}`);
          }
          response.status === 200
          ? setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Survey has been "+formData?.status.toLowerCase()+".",
          })
          : setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in saving data, please try again",
          });
          setShowLoader(false);
         setDisableButton(true);
            setTimeout(() => {
               handleCancel();
               const pathTemplate = "/client/:clientNameParam/property-view-details/:propertyMasterId/:inspectionRefnumber";
                const params = {
                  clientNameParam: clientNameParam,
                  propertyMasterId: propertyMasterId,
                  inspectionRefnumber: inspectionRefnumber
                };

                const fullPath = generatePath(pathTemplate, params);
            isApprove ? navigate(fullPath) 
            :  navigate(generatePath("/client/:clientNameParam/property-form", {
                    clientNameParam,
                  }));
        }, 3000);
         
        } catch (error) {
          console.error("API Error:", error);
          // Display error message to user, if needed
        }
        finally {
          setShowLoader(false);
        }
      }
    }
  };



  const handleFormDataChange = (e) => {
    setFormData({ ...formData, comment: e.target.value });
  };

  const handleCancel = () => {
      onClose();
  };
  const handleStatusChange = (e) => {
    setFormData({
      ...formData,
      status: e.target.value
    });
  }

const handleChange = (e) => {
  const selectedDate = new Date(e.target.value);
    const minDate = new Date(new Date().toISOString().split("T")[0]);

    if (selectedDate < minDate) {
      setDateError("Please select a valid future date.");
    } else {
      setDateError("");
    }
     setFormData({
      ...formData,
      dueDate: e.target.value
    });
  };

  return (
    <>
      <Toaster
                show={toastData.toastShow}
                toastType={toastData.toastType}
                title={toastData.toastString}
                theme={"dark"}
                position="top-center"
                closeButton={() => {closeButton() }}
              />
      {userObj && (
        <div className="dashboard_body_main d-flex vh-100">
          <div className="d-flex dashboard_body flex-column py-3 ">
            <div className="modal-overlay">
              <div className="approval-modal-content" style={{height:"fit-content"}}>
                <span className="close" onClick={handleCancel}>
                  &times;
                </span>
                <h6 className="modal-header">
                  {isApprove ? "Approval Information" : (isDueDate ? "Set Next Inspection Due Date" : "Rejection Information")}
                </h6>{" "}
                {/* Modal Header */}
                <div className="modal-body">
                  <div>
                    {isDueDate && <p>All doors of the property have been approved. 
                      Please set the next Inspection Due Date for this property</p>}
                    
                    <div className="row">
                      {!isDueDate && <div className="col-sm-6 col-md-6 mb-3">
                        <div className="form-floating">
                          <select
                            className="form-select"
                            id="floatingSelect"
                            disabled
                            aria-label="Floating label select example"
                            value={formData.status}
                            onChange={handleStatusChange}
                          >
                            <option selected>Select</option>
                            <option value="Approved">Approve</option>
                            <option value="Rejected">Reject</option>

                          </select>
                          <label htmlFor="floatingSelect">Status </label>
                        </div>
                      </div>}
                        <div className="col-sm-6 col-md-6 mb-3">
                      <div className="form-floating">
                        <input
                          type="date"
                          className="form-control"
                          id="date"
                          name="date"
                          min={new Date().toISOString().split("T")[0]}
                          value={formData.dueDate}
                          onChange={(e) => handleChange(e)}
                        />
                          <label htmlFor="date">Due Date <span style={{ color: 'red' }}>{isDueDate ? "*" : isApprove ? "*" : ""}</span></label>
                          {dateError && (
                            <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
                              {dateError}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {!isDueDate && <div className="form-floating">
                      <textarea
                        className="form-control"
                        rows="5"
                        style={{ minHeight: "auto", height: "auto" }}
                        placeholder="Comments"
                        value={formData.Comment}
                        id="floatingTextarea"
                        name="comment"
                        onChange={(e) => handleFormDataChange(e)}
                      ></textarea>
                      <label htmlFor="floatingTextarea">Comments {formData.status == "Rejected" ? <span style={{ color: 'red' }}>*</span> : ""}</label>
                    </div>}
                  </div>
                  <div className="row mt-3" style={{marginRight:"0px"}}>
                    {showLoader || disableButton ? (
                      <div className="approvalLoader" style={{ marginLeft: '45%' }}></div>
                    ) : (
                      <div>
                      <div> {validationFlag && <small style={{ color: 'red',float:'left' }} className=" mb-1">* Please fill all required fields</small>}</div>
                      <div className="card-body action_btns d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap">
                        
                        <button type="button" className="btn btn-tertiary" onClick={() => { handleCancel() }}>
                          Cancel
                        </button>
                        <button type="button" className="btn btn-primary" onClick={handleValidationOnSave} disabled={!!dateError}>
                          Submit
                        </button>
                      </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>)}
    </>
  );
};

export default Approval;